class BlankaboxProduct extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.handleClick = this.handleClick.bind(this);
    this.addEventListener('click', this.handleClick);

    this.purchase = this.querySelector('[data-bbp-purchase]');
    this.stickyBar = this.querySelector('[data-bbp-sticky-bar]');
    this.setupStickyBar();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.purchaseObserver?.disconnect();
  }

  handleClick(event) {
    const mediaButton = event.target.closest('[data-bbp-media-button]');
    if (mediaButton && this.contains(mediaButton)) {
      this.selectMedia(mediaButton);
      return;
    }

    const couponButton = event.target.closest('[data-bbp-coupon-button]');
    if (couponButton && this.contains(couponButton)) {
      this.selectCoupon(couponButton);
      return;
    }

    const stickySubmit = event.target.closest('[data-bbp-sticky-submit]');
    if (stickySubmit && this.contains(stickySubmit)) {
      this.querySelector('.bbp__product-form [ref="addToCartButton"]')?.click();
    }
  }

  selectMedia(button) {
    const mediaId = button.dataset.bbpMediaButton;
    if (!mediaId) return;

    const currentPanel = this.querySelector('.bbp__media-panel.is-active');
    const nextPanel = this.querySelector(`[data-bbp-media-panel="${CSS.escape(mediaId)}"]`);
    if (!nextPanel || nextPanel === currentPanel) return;

    currentPanel?.querySelector('video')?.pause();
    currentPanel?.classList.remove('is-active');
    if (currentPanel) currentPanel.hidden = true;

    nextPanel.hidden = false;
    nextPanel.classList.add('is-active');

    this.querySelectorAll('[data-bbp-media-button]').forEach((item) => {
      const isCurrent = item === button;
      item.classList.toggle('is-active', isCurrent);
      item.setAttribute('aria-current', String(isCurrent));
    });
  }

  selectCoupon(button) {
    const item = button.closest('.bbp__coupon-item');
    const template = item?.querySelector('[data-bbp-coupon-template]');
    const detail = this.querySelector('[data-bbp-coupon-detail]');
    if (!template || !detail) return;

    this.querySelectorAll('[data-bbp-coupon-button]').forEach((candidate) => {
      const isCurrent = candidate === button;
      candidate.classList.toggle('is-active', isCurrent);
      candidate.setAttribute('aria-pressed', String(isCurrent));
    });

    detail.replaceChildren(template.content.cloneNode(true));
  }

  setupStickyBar() {
    if (!this.purchase || !this.stickyBar || !('IntersectionObserver' in window)) return;

    this.purchaseObserver = new IntersectionObserver(
      ([entry]) => {
        const hasPassedPurchase = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        this.stickyBar.classList.toggle('is-visible', hasPassedPurchase);
        this.stickyBar.setAttribute('aria-hidden', String(!hasPassedPurchase));
      },
      { threshold: 0.02 }
    );

    this.purchaseObserver.observe(this.purchase);
  }
}

if (!customElements.get('blankabox-product')) {
  customElements.define('blankabox-product', BlankaboxProduct);
}
